export class AnnualEnrollmentRoutes {

	public static readonly AnnualEnrollment: string = '/annual-enrollment';

	public static readonly Coverage: string = '/coverage';

	public static readonly Review: string = '/review';

	public static readonly Confirmation: string = '/confirmation';	

	public static readonly InProgress: string = '/in-progress';

	public static readonly HeldInReview: string = '/held-in-review';

	public static readonly Resources: string = '/resources';

	public static readonly AdminAnnualEnrollmentResources: string = '/admin-annual-enrollment-resources';

	public static readonly ClientId: string = '/clientid';

	public static readonly GroupId: string = '/groupid';

	public static readonly BillingAccountId: string = '/billingaccountid';
}
